var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11_8553)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.46282 17.2672C9.16495 17.3821 8.83498 17.3821 8.53711 17.2672C6.21086 16.355 4.21342 14.7631 2.80524 12.699C1.39707 10.6349 0.643511 8.19443 0.642822 5.69574V1.9286C0.642822 1.5876 0.778281 1.26058 1.0194 1.01946C1.26052 0.778342 1.58754 0.642883 1.92854 0.642883H16.0714C16.4124 0.642883 16.7394 0.778342 16.9805 1.01946C17.2216 1.26058 17.3571 1.5876 17.3571 1.9286V5.68288C17.359 8.18376 16.6066 10.6271 15.1983 12.6937C13.79 14.7604 11.7911 16.3542 9.46282 17.2672Z",
    stroke: "white",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.64746 13.7957C4.23391 12.9134 5.02954 12.1899 5.96342 11.6896C6.89731 11.1894 7.94045 10.9279 8.99989 10.9286C11.2332 10.9286 13.2003 12.0677 14.3536 13.7957",
    stroke: "white",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.00004 9.00001C9.37993 9.00001 9.75611 8.92518 10.1071 8.7798C10.4581 8.63442 10.777 8.42134 11.0456 8.15271C11.3142 7.88408 11.5273 7.56518 11.6727 7.2142C11.8181 6.86322 11.8929 6.48705 11.8929 6.10715C11.8929 5.72726 11.8181 5.35108 11.6727 5.0001C11.5273 4.64913 11.3142 4.33022 11.0456 4.06159C10.777 3.79297 10.4581 3.57988 10.1071 3.4345C9.75611 3.28912 9.37993 3.21429 9.00004 3.21429C8.2328 3.21429 7.49699 3.51908 6.95448 4.06159C6.41196 4.60411 6.10718 5.33992 6.10718 6.10715C6.10718 6.87439 6.41196 7.61019 6.95448 8.15271C7.49699 8.69523 8.2328 9.00001 9.00004 9.00001Z",
    stroke: "white",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11_8553"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.0b55ca9ca0bd57c84fa37b2dbef1f276.svg";
export { ForwardRef as ReactComponent };